import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Legal.css';

const Legal = () => {
  return (
    <div className="legal">
      <Helmet>
        <title>Yasal Uyarı | Ünal Döviz - Kullanım Koşulları ve Gizlilik</title>
        <meta name="description" content="Ünal Döviz yasal uyarı, kullanım koşulları, gizlilik politikası, KVKK uyumu ve B Grubu yetkili müessese bilgileri." />
        <meta name="keywords" content="Ünal Döviz yasal uyarı, kullanım koşulları, gizlilik politikası, KVKK, Gaziemir döviz bürosu" />
        <link rel="canonical" href="https://unaldoviz.com/yasal-uyari" />
        <meta property="og:title" content="Yasal Uyarı | Ünal Döviz - Kullanım Koşulları ve Gizlilik" />
        <meta property="og:description" content="Ünal Döviz yasal uyarı, kullanım koşulları, gizlilik politikası ve yasal bilgiler." />
        <meta property="og:url" content="https://unaldoviz.com/yasal-uyari" />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      {/* Hero Section */}
      <section className="legal-hero">
        <div className="container">
          <div className="legal-hero-content text-center">
            <h1 className="legal-title">Yasal Uyarı</h1>
            <p className="legal-subtitle">
              Hukuki bilgiler ve kullanım koşulları
            </p>
          </div>
        </div>
      </section>

      {/* Legal Content */}
      <section className="legal-content section-padding">
        <div className="container">
          <div className="legal-document">
            
            <div className="legal-section">
              <h2 className="section-title">1. Genel Bilgiler</h2>
              <div className="section-content">
                <p>
                  Bu web sitesi Ünal Döviz Sınırlı Yetkili Müessese A.Ş. tarafından işletilmektedir. 
                  Sitemizi ziyaret etmek ve hizmetlerimizden yararlanmak için 
                  aşağıdaki şartları kabul etmiş sayılırsınız.
                </p>
                <div className="company-info">
                  <h3>Şirket Bilgileri:</h3>
                  <ul>
                    <li><strong>Ünvan:</strong> Ünal Döviz Sınırlı Yetkili Müessese A.Ş.</li>
                    <li><strong>Adres:</strong> Atıfbey Mah. 5 Sk. No: 90/B, Gaziemir/İzmir</li>
                    <li><strong>Telefon:</strong> 0 232 252 53 90 / 0 232 252 53 91</li>
                    <li><strong>E-posta:</strong> info@unaldoviz.com</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="legal-section">
              <h2 className="section-title">2. Hizmet Kapsamı</h2>
              <div className="section-content">
                <p>
                  Ünal Döviz olarak, B Grubu Sınırlı Yetkili Müessese 
                  statümüz ve yürürlükteki mevzuat çerçevesinde aşağıdaki hizmetleri sunuyoruz:
                </p>
                <ul>
                  <li>Döviz alım-satım işlemleri</li>
                  <li>Yurt içi havale işlemleri</li>
                  <li>Altın alım-satım işlemleri</li>
                  <li>Müşterilerimize işlem süreçleri hakkında bilgilendirme</li>
                </ul>
                <p>
                  Tüm işlemler, yürürlükteki yasal düzenlemelere ve yetkili kurumların 
                  ilgili talimatlarına uygun olarak gerçekleştirilmektedir.
                </p>
              </div>
            </div>

            <div className="legal-section">
              <h2 className="section-title">3. Kullanım Koşulları</h2>
              <div className="section-content">
                <p>
                  Web sitemizi kullanırken aşağıdaki kurallara uymanız gerekmektedir:
                </p>
                <ul>
                  <li>Sitede yer alan bilgileri ticari amaçlarla kullanmamak</li>
                  <li>Site güvenliğini tehlikeye atacak eylemlerden kaçınmak</li>
                  <li>Yanıltıcı veya yanlış bilgi vermemek</li>
                  <li>Telif haklarına saygı göstermek</li>
                  <li>Yasal düzenlemelere aykırı işlemler yapmamak</li>
                </ul>
              </div>
            </div>

            <div className="legal-section">
              <h2 className="section-title">4. Gizlilik ve Kişisel Verilerin Korunması</h2>
              <div className="section-content">
                <p>
                  Müşterilerimizin kişisel verileri, 6698 sayılı Kişisel Verilerin 
                  Korunması Kanunu (KVKK) kapsamında korunmaktadır. Kişisel verileriniz:
                </p>
                <ul>
                  <li>Sadece hizmet sunumu amacıyla toplanır</li>
                  <li>Üçüncü kişilerle paylaşılmaz</li>
                  <li>Güvenli sistemlerde saklanır</li>
                  <li>Yasal süre sonunda imha edilir</li>
                </ul>
                <p>
                  Detaylı bilgi için <strong>Kişisel Verilerin Korunması Politikamızı</strong> 
                  inceleyebilirsiniz.
                </p>
              </div>
            </div>

            <div className="legal-section">
              <h2 className="section-title">5. Sorumluluk Sınırlaması</h2>
              <div className="section-content">
                <p>
                  Ünal Döviz aşağıdaki konularda sorumluluk kabul etmez:
                </p>
                <ul>
                  <li>Döviz kurlarındaki dalgalanmalardan kaynaklanan zararlar</li>
                  <li>Teknik arızalar nedeniyle oluşabilecek kesintiler</li>
                  <li>Üçüncü kişilerin neden olduğu zararlar</li>
                  <li>Mücbir sebeplerden kaynaklanan durumlar</li>
                  <li>Müşteri hatalarından kaynaklanan sorunlar</li>
                </ul>
                <p>
                  Ancak, yasal yükümlülüklerimiz çerçevesinde gerekli özen 
                  gösterilmektedir.
                </p>
              </div>
            </div>

            <div className="legal-section">
              <h2 className="section-title">6. Fikri Mülkiyet Hakları</h2>
              <div className="section-content">
                <p>
                  Bu web sitesinde yer alan tüm içerik, tasarım, logo, metin, 
                  görsel ve diğer materyaller Ünal Döviz'in fikri
                  mülkiyetindedir. İzinsiz kullanım yasaktır.
                </p>
                <p>
                  Site içeriğinin kopyalanması, çoğaltılması, dağıtılması veya 
                  ticari amaçlarla kullanılması yasal işlem gerektirir.
                </p>
              </div>
            </div>

            <div className="legal-section">
              <h2 className="section-title">7. Çerezler (Cookies)</h2>
              <div className="section-content">
                <p>
                  Web sitemiz, kullanıcı deneyimini iyileştirmek amacıyla çerezler 
                  kullanmaktadır. Çerezler hakkında bilgiler:
                </p>
                <ul>
                  <li>Site performansını artırmak için kullanılır</li>
                  <li>Kişisel tercihlerinizi hatırlar</li>
                  <li>İstatistiksel analiz için veri toplar</li>
                  <li>Tarayıcı ayarlarından kontrol edilebilir</li>
                </ul>
              </div>
            </div>

            <div className="legal-section">
              <h2 className="section-title">8. Değişiklikler</h2>
              <div className="section-content">
                <p>
                  Ünal Döviz, bu yasal uyarı metnini önceden haber vermeksizin 
                  değiştirme hakkını saklı tutar. Değişiklikler web sitesinde 
                  yayınlandığı tarihte yürürlüğe girer.
                </p>
                <p>
                  Sitemizi düzenli olarak ziyaret ederek güncel koşulları 
                  takip etmenizi öneririz.
                </p>
              </div>
            </div>

            <div className="legal-section">
              <h2 className="section-title">9. Uygulanacak Hukuk ve Yetki</h2>
              <div className="section-content">
                <p>
                  Bu yasal uyarı ve web sitesi kullanımından doğabilecek 
                  uyuşmazlıklarda Türkiye Cumhuriyeti hukuku uygulanır.
                </p>
                <p>
                  Uyuşmazlıkların çözümünde İstanbul Mahkemeleri ve İcra 
                  Müdürlükleri yetkilidir.
                </p>
              </div>
            </div>

            <div className="legal-section">
              <h2 className="section-title">10. İletişim</h2>
              <div className="section-content">
                <p>
                  Bu yasal uyarı ile ilgili sorularınız için bizimle iletişime geçebilirsiniz:
                </p>
                <div className="contact-info">
                  <p><strong>E-posta:</strong> info@unaldoviz.com</p>
                  <p><strong>Telefon:</strong> 0 232 252 53 90 / 0 232 252 53 91</p>
                  <p><strong>Adres:</strong> Atıfbey Mah. 5 Sk. No: 90/B, Gaziemir/İzmir</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Legal;